export default __webpack_public_path__ + "static/media/black-collateral.e2a68548.png";